import { Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title);

const doughnut_chart = ({ data, areaName, termTab }) => {
    
    const myKeys = ['MY_KTS1', 'MY_KTS2', 'MY_KTS3', 'MY_KTS4', 'MY_KTS5'];
    const allKeys = ['ALL_KTS1', 'ALL_KTS2', 'ALL_KTS3', 'ALL_KTS4', 'ALL_KTS5'];
    const keys = ['KTS1', 'KTS2', 'KTS3', 'KTS4', 'KTS5'];

    const myKtsList = myKeys.map(key => data?.reduce((acc, item) => acc + (item[key] ?? 0), 0));
    const allKtsList = allKeys.map(key => data?.reduce((acc, item) => acc + (item[key] ?? 0), 0));
    const ktsList = keys.map(key => data?.reduce((acc, item) => acc + (item[key] ?? 0), 0));

    const labels = ['1단계', '2단계', '3단계', '4단계', '5단계'];

    const options = {
        maintainAspectRatio: false,
        responsive: true,
        spanGaps: false,
        layout: {
            padding: {
                bottom: 10
            }
        },
        plugins: {
            legend: {
                position: 'left',
                display: false,
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    padding: 20,
                },
            },
            title: {
                display: false,
                text: '전체 KTAS 등급',
                align: 'start',
                font: {size: 16},
                padding: {bottom: 20}
            }
        },
    }
    
    const chartData = {
        labels,
        datasets: 
            [
                {
                    type: 'doughnut',
                    data: areaName !== undefined ? myKtsList : termTab !== 'day' ? ktsList : allKtsList,
                    backgroundColor: [
                                      "rgb(101, 171, 235)",
                                      "rgb(230, 121, 143)",
                                      "rgb(246, 215, 106)",
                                      "rgb(131, 199, 200)",
                                      "rgb(143, 107, 229)",
                                    ],
                    borderColor: 'white',
                    borderWidth: 0.5,
                    hoverOffset: 6,
                },
            ] 
    }
    
    // 범례(percentage)
    const myKtsRatio = myKtsList?.map(value => ((value / myKtsList?.reduce((acc, item) => acc + item, 0))*100).toFixed(2));
    const allKtsRatio = allKtsList?.map(value => ((value / allKtsList?.reduce((acc, item) => acc + item, 0))*100).toFixed(2));
    const ktsRatio = ktsList?.map(value => ((value / ktsList?.reduce((acc, item) => acc + item, 0))*100).toFixed(2));

    const percentageData = areaName !== undefined ? myKtsRatio : termTab !== 'day' ? ktsRatio : allKtsRatio

    const legend = [
        {title: '1단계', color: 'rgb(101, 171, 235)'},
        {title: '2단계', color: 'rgb(230, 121, 143)'},
        {title: '3단계', color: 'rgb(246, 215, 106)'},
        {title: '4단계', color: 'rgb(131, 199, 200)'},
        {title: '5단계', color: 'rgb(143, 107, 229)'},
    ];

    const ktasLegend = legend.map((item, idx) => ({
        ...item,
        data: `${percentageData[idx]}%`
    }))
    
    return (
        <>
            <div className='ktas_legend_wapper wp-30'>
                {ktasLegend.map((item, idx) => 
                    <div key={idx} className='legend'>
                        <div className='legend_icon' style={{backgroundColor: item.color}}/>
                        <span>{item.title}</span><span className='font-bold' style={{color: item.color}}>{item.data}</span>
                    </div>
                )}
            </div>
            <div className='ktas_chart_box wp-70'>
                <Pie data={chartData} options={options} />
            </div>
        </>
    );
};

export default doughnut_chart;
